const PREFIX = 'schedule-settings';

export const SETTINGS_TRACKING_IDS = {
  appointmentHours: {
    saveButton: `${PREFIX}:appointment-hours:save-button`,
  },
  manageProviders: {
    addProviderButton: `${PREFIX}:manage-providers:add-provider-button`,
    saveScheduleButton: `${PREFIX}:manage-providers:provider-schedule:save-button`,
    showOnCalendarToggleButton: `${PREFIX}:manage-providers:show-on-calendar-toggle-button`,
  },
};
